const FORM_BASE =
  "https://docs.google.com/forms/d/e/1FAIpQLSeo9k4N74EifSypZUikxebTUG9KFEMkcLIFy8CCXjj3kcQMMg/viewform?usp=pp_url&entry.1985922119=";

const sharedFeatures = [
  "Industry Expert Instructors",
  "Certification Support",
  "100% Placement Support",
  "Flexible Learning",
  "Industry Projects",
  "Career Guidance",
];

const sharedStats = [
  { value: "32%", label: "Market Share" },
  { value: "₹15L", label: "Avg. Salary" },
  { value: "1M+", label: "Job Openings" },
  { value: "95%", label: "Placement Rate" },
];

const careerServices = [
  { title: "Resume Building", desc: "ATS-optimized resumes highlighting your cloud skills and project experience." },
  { title: "Interview Preparation", desc: "Mock interviews and technical question practice with industry engineers." },
  { title: "LinkedIn Optimization", desc: "Profile makeover to showcase your cloud expertise and certifications." },
  { title: "Direct Job Placements", desc: "Partnerships with 200+ companies with average 80–150% salary growth." },
  { title: "Portfolio Development", desc: "Build a GitHub portfolio with real cloud projects and deployments." },
  { title: "Certification Guidance", desc: "Structured support to clear cloud certification exams on first attempt." },
];

export const courseCatalog = [
  {
    slug: "gcp",
    title: "GCP",
    cardTitle: "Google Cloud Platform (GCP)",
    image: "/images/gcp.png",
    rating: "5.0",
    ratingsCount: 3,
    duration: "4 Months",
    projects: "5 Projects",
    tech: "Compute Engine, Cloud Storage, VPC, IAM, GKE",
    formLink: `${FORM_BASE}GCP`,
  },
  {
    slug: "devops",
    title: "DevOps",
    cardTitle: "DevOps",
    image: "/images/devops.png",
    rating: "5.0",
    ratingsCount: 3,
    duration: "6 Months",
    projects: "10 Projects",
    tech: "AWS, Docker, Kubernetes, Jenkins, Linux",
    formLink: `${FORM_BASE}DevOps`,
  },
  {
    slug: "aws",
    title: "AWS",
    cardTitle: "Amazon Web Services",
    image: "/images/aws-s3.png",
    rating: "5.0",
    ratingsCount: 3,
    duration: "3 Months",
    projects: "3 Projects",
    tech: "EC2, S3, Lambda, Terraform, IAM",
    formLink: `${FORM_BASE}AWS`,
  },
  {
    slug: "azure",
    title: "Azure",
    cardTitle: "Microsoft Azure",
    image: "/images/azure.png",
    rating: "5.0",
    ratingsCount: 3,
    duration: "4 Months",
    projects: "4 Projects",
    tech: "VMs, Blob Storage, Azure AD, App Service",
    formLink: `${FORM_BASE}Azure`,
  },
  {
    slug: "genai",
    title: "GenAI",
    cardTitle: "Generative AI",
    image: "/images/genAI.png",
    rating: "5.0",
    ratingsCount: 3,
    duration: "3 Months",
    projects: "4 Projects",
    tech: "LLMs, Prompt Engineering, APIs, RAG",
    formLink: `${FORM_BASE}GenAI`,
  },
  {
    slug: "python",
    title: "Python",
    cardTitle: "Python Programming",
    image: "/images/python.png",
    rating: "5.0",
    ratingsCount: 3,
    duration: "3 Months",
    projects: "5 Projects",
    tech: "Python, APIs, Automation, OOP",
    formLink: `${FORM_BASE}Python`,
  },
  {
    slug: "dataengineering",
    title: "Data Engineering",
    cardTitle: "Data Engineering",
    image: "/images/dataengineering.png",
    rating: "5.0",
    ratingsCount: 3,
    duration: "5 Months",
    projects: "6 Projects",
    tech: "ETL, Spark, Airflow, Data Warehousing",
    formLink: `${FORM_BASE}Data+Engineering`,
  },
];

export const courseDetails = [
  {
    slug: "gcp",
    title: "Google Cloud Platform (GCP)",
    description:
      "Master Google Cloud Platform and accelerate your career in cloud computing. Learn how to build, deploy, and manage scalable applications on one of the world's most powerful cloud platforms.",
    image: "/images/gcp.png",
    formLink: `${FORM_BASE}GCP`,
    stats: sharedStats,
    features: sharedFeatures,
    overview: [
      {
        title: "What is GCP?",
        text: "Google Cloud Platform (GCP) is a suite of cloud computing services that runs on the same infrastructure Google uses internally. It offers compute, storage, networking, big data, machine learning, and IoT services.",
      },
      {
        title: "Why Choose GCP?",
        text: "GCP leads in AI, data analytics, and Kubernetes. Cloud engineers with GCP skills earn ₹7–22 LPA. GCP's global network and innovative services make it ideal for modern cloud careers.",
      },
    ],
    skills: [
      { title: "GCP Fundamentals", subtitle: "Regions, Zones, Global Infrastructure" },
      { title: "Core Services", subtitle: "Compute Engine, Cloud Storage, Cloud SQL, Firestore" },
      { title: "Networking", subtitle: "VPC, Load Balancing, Cloud DNS" },
      { title: "Serverless Computing", subtitle: "Cloud Functions, Pub/Sub" },
      { title: "Security & Identity", subtitle: "IAM, Cloud KMS, Firewall Rules" },
      { title: "Automation", subtitle: "Deployment Manager, Cloud SDK" },
      { title: "Monitoring & Logging", subtitle: "Cloud Monitoring, Cloud Logging" },
      { title: "Networking Security", subtitle: "Shared VPC, Private Google Access" },
    ],
    tools: [
      { title: "Management Tools", items: ["Google Cloud Console", "Cloud SDK (gcloud CLI)", "Deployment Manager"] },
      { title: "Core Services", items: ["Compute Engine", "Cloud Storage", "Cloud SQL", "Firestore"] },
      { title: "Networking Tools", items: ["VPC & Firewall Rules", "Load Balancing", "Cloud DNS", "Shared VPC"] },
      { title: "Security Tools", items: ["Identity & Access Management (IAM)", "Cloud KMS", "Private Google Access"] },
      { title: "Monitoring Tools", items: ["Cloud Monitoring", "Cloud Logging"] },
    ],
    syllabus: [
      { title: "GCP Fundamentals & Global Infrastructure", items: ["Cloud concepts", "GCP console", "Projects and billing", "Regions and zones"] },
      { title: "Core GCP Services", items: ["Compute Engine", "Cloud Storage", "Cloud SQL", "Firestore"] },
      { title: "Security and Networking", items: ["VPC design", "IAM roles", "Firewall rules", "Load balancing"] },
      { title: "Projects", items: ["Deploy web app on GCP", "Multi-tier architecture", "Monitoring setup"] },
    ],
    careerServices,
  },
  {
    slug: "devops",
    title: "DevOps",
    description:
      "Build production-ready delivery pipelines with infrastructure automation, containers, CI/CD, and monitoring workflows used by top engineering teams.",
    image: "/images/devops.png",
    formLink: `${FORM_BASE}DevOps`,
    stats: sharedStats,
    features: sharedFeatures,
    overview: [
      { title: "What is DevOps?", text: "DevOps combines development and operations to deliver software faster with automation, collaboration, and continuous improvement." },
      { title: "Why Choose DevOps?", text: "DevOps engineers are among the highest-paid IT roles. Companies need professionals who can automate deployments and manage cloud infrastructure." },
    ],
    skills: [
      { title: "Linux & Git", subtitle: "Shell scripting, branching, workflows" },
      { title: "CI/CD", subtitle: "Jenkins, GitHub Actions, pipelines" },
      { title: "Containers", subtitle: "Docker, Kubernetes, Helm" },
      { title: "Infrastructure as Code", subtitle: "Terraform, Ansible" },
    ],
    tools: [
      { title: "Version Control", items: ["Git", "GitHub", "GitLab"] },
      { title: "CI/CD", items: ["Jenkins", "GitHub Actions", "ArgoCD"] },
      { title: "Containers", items: ["Docker", "Kubernetes", "Helm"] },
      { title: "IaC", items: ["Terraform", "Ansible", "CloudFormation"] },
    ],
    syllabus: [
      { title: "DevOps Foundations", items: ["Linux basics", "Git workflows", "Agile culture"] },
      { title: "CI/CD Pipelines", items: ["Jenkins", "GitHub Actions", "Build automation"] },
      { title: "Containers & Orchestration", items: ["Docker", "Kubernetes", "Helm basics"] },
      { title: "Projects", items: ["End-to-end pipeline", "Microservices deployment", "Monitoring stack"] },
    ],
    careerServices,
  },
  {
    slug: "aws",
    title: "Amazon Web Services",
    description:
      "Master cloud computing with AWS – the world's leading cloud platform. Learn to design, deploy, and manage scalable applications using EC2, S3, Lambda, and more.",
    image: "/images/aws-s3.png",
    formLink: `${FORM_BASE}AWS`,
    stats: sharedStats,
    features: sharedFeatures,
    overview: [
      { title: "What is AWS?", text: "Amazon Web Services is the most widely adopted cloud platform, offering over 200 services for compute, storage, databases, and machine learning." },
      { title: "Why Choose AWS?", text: "AWS holds the largest cloud market share. Certified AWS professionals are in high demand with strong salary growth across India and globally." },
    ],
    skills: [
      { title: "AWS Core Services", subtitle: "EC2, S3, VPC, RDS" },
      { title: "Cloud Architecture", subtitle: "Design & deploy solutions" },
      { title: "Security & Compliance", subtitle: "IAM, KMS, CloudTrail" },
      { title: "Serverless", subtitle: "Lambda, API Gateway, DynamoDB" },
    ],
    tools: [
      { title: "Management", items: ["AWS Console", "AWS CLI", "CloudFormation"] },
      { title: "Compute", items: ["EC2", "Lambda", "ECS/EKS"] },
      { title: "Storage", items: ["S3", "EBS", "EFS"] },
      { title: "Security", items: ["IAM", "KMS", "WAF"] },
    ],
    syllabus: [
      { title: "Introduction to AWS", items: ["AWS global infrastructure", "Pricing models", "Free tier"] },
      { title: "Compute Services", items: ["EC2", "Lambda", "Auto Scaling"] },
      { title: "Storage & Databases", items: ["S3", "RDS", "DynamoDB"] },
      { title: "Projects", items: ["Two-tier architecture", "Serverless API", "Migration project"] },
    ],
    careerServices,
  },
  {
    slug: "azure",
    title: "Microsoft Azure",
    description:
      "Master Azure cloud services including VMs, storage, Azure SQL, functions, identity, and enterprise cloud deployment workflows.",
    image: "/images/azure.png",
    formLink: `${FORM_BASE}Azure`,
    stats: sharedStats,
    features: sharedFeatures,
    overview: [
      { title: "What is Azure?", text: "Microsoft Azure is an enterprise cloud platform offering virtual machines, app services, databases, and AI tools integrated with the Microsoft ecosystem." },
      { title: "Why Choose Azure?", text: "Azure is the preferred cloud for enterprises using Microsoft products. Azure skills open doors to corporate and hybrid-cloud roles." },
    ],
    skills: [
      { title: "Azure Fundamentals", subtitle: "Portal, subscriptions, resource groups" },
      { title: "Compute", subtitle: "Virtual Machines, App Services" },
      { title: "Storage", subtitle: "Blob, Files, Disks" },
      { title: "Identity", subtitle: "Azure AD, RBAC" },
    ],
    tools: [
      { title: "Management", items: ["Azure Portal", "Azure CLI", "ARM Templates"] },
      { title: "Compute", items: ["Virtual Machines", "Azure Functions", "App Service"] },
      { title: "Data", items: ["Blob Storage", "Azure SQL", "Cosmos DB"] },
      { title: "Security", items: ["Azure AD", "Key Vault", "RBAC"] },
    ],
    syllabus: [
      { title: "Azure Basics", items: ["Cloud models", "Azure regions", "Resource management"] },
      { title: "Compute Services", items: ["Virtual Machines", "Azure Functions", "App Service"] },
      { title: "Data & Storage", items: ["Blob Storage", "Azure SQL", "Data Lake"] },
      { title: "Projects", items: ["Deploy app on Azure", "Secure cloud architecture"] },
    ],
    careerServices,
  },
  {
    slug: "genai",
    title: "Generative AI",
    description:
      "Learn generative AI fundamentals, prompt engineering, LLM APIs, automation use cases, and practical AI-assisted workflows for modern careers.",
    image: "/images/genAI.png",
    formLink: `${FORM_BASE}GenAI`,
    stats: sharedStats,
    features: sharedFeatures,
    overview: [
      { title: "What is GenAI?", text: "Generative AI uses large language models to create text, code, images, and automate workflows — transforming how businesses operate." },
      { title: "Why Choose GenAI?", text: "AI skills are the fastest-growing demand in tech. Learn to build AI-powered tools and stay ahead in the job market." },
    ],
    skills: [
      { title: "AI Basics", subtitle: "LLMs, transformers overview" },
      { title: "Prompt Engineering", subtitle: "Effective prompts and RAG" },
      { title: "APIs", subtitle: "OpenAI and similar APIs" },
      { title: "Automation", subtitle: "AI in business workflows" },
    ],
    tools: [
      { title: "Frameworks", items: ["LangChain", "OpenAI API", "Hugging Face"] },
      { title: "Development", items: ["Python", "FastAPI", "Vector DBs"] },
      { title: "Use Cases", items: ["Chatbots", "Document AI", "Code assistants"] },
    ],
    syllabus: [
      { title: "GenAI Introduction", items: ["AI landscape", "Use cases", "Ethics"] },
      { title: "Prompt Engineering", items: ["Prompt patterns", "RAG overview", "Evaluation"] },
      { title: "Building with APIs", items: ["API integration", "Chatbots", "Automation"] },
      { title: "Projects", items: ["AI assistant", "Workflow automation", "Portfolio project"] },
    ],
    careerServices,
  },
  {
    slug: "python",
    title: "Python Programming",
    description:
      "Learn Python programming, automation, APIs, data handling, and project development for cloud, DevOps, and AI career paths.",
    image: "/images/python.png",
    formLink: `${FORM_BASE}Python`,
    stats: sharedStats,
    features: sharedFeatures,
    overview: [
      { title: "What is Python?", text: "Python is a versatile programming language used in web development, data science, automation, cloud scripting, and AI." },
      { title: "Why Choose Python?", text: "Python is the #1 language for beginners and professionals alike. It powers DevOps automation, data pipelines, and AI applications." },
    ],
    skills: [
      { title: "Python Basics", subtitle: "Syntax, data types, functions" },
      { title: "OOP", subtitle: "Classes, modules, packages" },
      { title: "APIs & Automation", subtitle: "Requests, scripting" },
      { title: "Projects", subtitle: "Real-world applications" },
    ],
    tools: [
      { title: "Core", items: ["Python 3", "pip", "virtualenv"] },
      { title: "Libraries", items: ["Requests", "Pandas", "Flask"] },
      { title: "DevOps", items: ["Boto3", "CLI tools", "Scripting"] },
    ],
    syllabus: [
      { title: "Python Fundamentals", items: ["Variables", "Control flow", "Functions"] },
      { title: "Intermediate Python", items: ["OOP", "File handling", "Error handling"] },
      { title: "Libraries & APIs", items: ["Requests", "JSON", "Automation scripts"] },
      { title: "Projects", items: ["CLI tools", "API integration", "Mini applications"] },
    ],
    careerServices,
  },
  {
    slug: "dataengineering",
    title: "Data Engineering",
    description:
      "Build ETL pipelines, data warehousing, Spark concepts, workflow orchestration, and cloud data platform fundamentals.",
    image: "/images/dataengineering.png",
    formLink: `${FORM_BASE}Data+Engineering`,
    stats: sharedStats,
    features: sharedFeatures,
    overview: [
      { title: "What is Data Engineering?", text: "Data engineering designs and builds systems for collecting, storing, and processing large volumes of data for analytics and AI." },
      { title: "Why Choose Data Engineering?", text: "Data engineers are critical to every data-driven company. Salaries and demand continue to grow across cloud and AI sectors." },
    ],
    skills: [
      { title: "ETL Pipelines", subtitle: "Extract, transform, load" },
      { title: "Data Warehousing", subtitle: "Snowflake, Redshift concepts" },
      { title: "Big Data", subtitle: "Spark, Hadoop overview" },
      { title: "Orchestration", subtitle: "Airflow workflows" },
    ],
    tools: [
      { title: "Processing", items: ["Apache Spark", "Pandas", "SQL"] },
      { title: "Orchestration", items: ["Airflow", "dbt", "Kafka basics"] },
      { title: "Cloud Data", items: ["BigQuery", "Redshift", "Data Lake"] },
    ],
    syllabus: [
      { title: "Data Engineering Basics", items: ["ETL concepts", "Data lakes", "Data quality"] },
      { title: "Big Data Tools", items: ["Spark", "Hadoop ecosystem"] },
      { title: "Cloud Data Platforms", items: ["AWS/GCP data services", "Warehousing"] },
      { title: "Projects", items: ["End-to-end pipeline", "Batch processing", "Streaming intro"] },
    ],
    careerServices,
  },
];

export function getCourseBySlug(slug) {
  return courseDetails.find((c) => c.slug === slug);
}

export function getCoursePath(slug, hash) {
  return hash ? `/courses/${slug}${hash}` : `/courses/${slug}`;
}
